import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { API_ENDPOINTS, METHOD_TYPE } from "../../utils/apiUrls";
import api from "../../utils/api";

const initialState = {
    isLoading: false,
    error: null,
    amlCheckSearchLists: { rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200 }
}

export const getPreviousSearchRecords = createAsyncThunk("user/getPreviousSearchRecords", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getPreviousSearchRecords + queryParams
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const initialSearch = createAsyncThunk("user/initialSearch", async (payload) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.initialSearch,
            data: payload
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const manageContinuousMonitoring = createAsyncThunk("user/manageContinuousMonitoring", async (params) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.amlCheckManageContinuousMonitoring + params.queryParams,
            data: params?.payload
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const getContinuousMonitoringPrice = createAsyncThunk("amlCheck/getContinuousMonitoringPrice", async (amlCheckSearchId) => {
    try {
        const response = await api({
            method: METHOD_TYPE.get,
            url: `${API_ENDPOINTS.amlCheckContinuousMonitoringPrice}?aml_check_search_id=${amlCheckSearchId}`
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data || error;
    }
});

export const deleteAmlCheck = createAsyncThunk("amlCheck/deleteAmlCheck", async (amlCheckSearchId) => {
    try {
        const response = await api({
            method: METHOD_TYPE.delete,
            url: API_ENDPOINTS.deleteAmlCheck,
            data: { aml_check_search_id: amlCheckSearchId }
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data || error;
    }
});

export const startAmlFullOnboarding = createAsyncThunk("amlCheck/startFullOnboarding", async (payload) => {
    try {
        const response = await api({
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.startAmlFullOnboarding,
            data: payload,
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const generateOnboardingInviteLink = createAsyncThunk("user/generateOnboardingInviteLink", async (payload) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.generateOnboardingInviteLink,
            data: payload
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

const amlCheckSlice = createSlice({
    name: "amlCheck",
    initialState,
    reducers: {
        updatePreviousSearchRecords(state, action) {
            state.amlCheckSearchLists = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPreviousSearchRecords.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
                state.amlCheckSearchLists = payload?.data;
            })
            .addCase(initialSearch.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(manageContinuousMonitoring.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(startAmlFullOnboarding.fulfilled, (state) => {
                state.isLoading = false;
                state.error = null;
            })
            .addMatcher(isAnyOf(getPreviousSearchRecords.pending, initialSearch.pending, manageContinuousMonitoring.pending, startAmlFullOnboarding.pending, deleteAmlCheck.pending), (state) => {
                state.isLoading = true;
            })
            .addMatcher(isAnyOf(getPreviousSearchRecords.rejected, initialSearch.rejected, manageContinuousMonitoring.rejected, startAmlFullOnboarding.rejected, deleteAmlCheck.rejected), (state, { error }) => {
                state.isLoading = false;
                state.error = error.message ? error.message : "Request Failed Please Try Again ";
            })
    }
});

const { updatePreviousSearchRecords } = amlCheckSlice.actions;
const amlCheckReducer = amlCheckSlice.reducer;

export { updatePreviousSearchRecords, amlCheckReducer };
export default amlCheckReducer;
